import React, { useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "../../utils/utils";
import useQuickbooksApi from "../../hooks/useQuickbooksApi";
import useMixpanelEventAction from "../../config/mixpanel/useMixpanelEventAction";
import useGA4EventAction from "../../config/GoogleAnalytics/useGA4EventAction";
import { showToastType } from "../../utils/constants/appConstants";
import {
  callBackComp,
  invcsConnect,
  optimizationTexts
} from "../../locales/en";
import { INVOICE } from "../../route/paths";

const QuickBooksCallBack = () => {
  const navigate = useNavigate();
  const initialRender = useRef(true);
  const { QuickBooksCallBack } = useQuickbooksApi();
  const { quickbookConnectMixpanelEvent } = useMixpanelEventAction();
  const { quickbookConnectGA4Event } = useGA4EventAction();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParams = queryParams.get("code");
  const realmIdParams = queryParams.get("realmId");
  const stateParams = queryParams.get("state");

  const handleQuickBooksCallBack = useCallback(async () => {
    try {
      const response = await QuickBooksCallBack({
        code: codeParams,
        realmId: realmIdParams,
        state: stateParams
      });
      await quickbookConnectGA4Event();
      if (!response.data.data.BookIdDetails) {
        quickbookConnectMixpanelEvent();
        showToast(optimizationTexts?.quickBooksSoftware, showToastType.success);
      }

      navigate(INVOICE, {
        state: {
          BookIdDetails: response.data.BookIdDetails
            ? response.data.BookIdDetails
            : null,
          softwareType: "QUICKBOOKS"
        }
      });
    } catch (err) {
      console.error(invcsConnect.errMsg.item1, err);
      navigate(INVOICE);
    }
  }, [
    QuickBooksCallBack,
    codeParams,
    navigate,
    realmIdParams,
    stateParams,
    quickbookConnectMixpanelEvent,
    quickbookConnectGA4Event
  ]);

  useEffect(() => {
    if (initialRender.current) {
      handleQuickBooksCallBack();
      initialRender.current = false;
    }
  }, [handleQuickBooksCallBack]);

  return <h5 className="text-dark">{callBackComp.doNotRefresh}</h5>;
};

export default QuickBooksCallBack;
